import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { DATA_VIZ_COLORS } from "../../../config/chartColors";
import type { LearningVelocity } from "../../../generated/graphql";

interface LearningVelocityChartProps {
  data: LearningVelocity[];
}

export function LearningVelocityChart({ data }: LearningVelocityChartProps) {
  if (!data || data.length === 0) {
    return (
      <div className="chart-container">
        <div className="chart-empty">No learning velocity data available</div>
      </div>
    );
  }

  const chartData = data.map((velocity) => ({
    date: new Date(velocity.date).toLocaleDateString(),
    learned: velocity.cardsLearned,
    reviewed: velocity.cardsReviewed,
    studyTime: velocity.studyTimeMinutes,
  }));

  return (
    <div className="chart-container">
      <div className="chart-header">
        <h4 className="h6">Learning Velocity</h4>
      </div>
      <div className="chart-body">
        <ResponsiveContainer width="100%" height={400}>
          <AreaChart data={chartData}>
            <defs>
              <linearGradient id="colorLearned" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={DATA_VIZ_COLORS.success} stopOpacity={0.8} />
                <stop offset="95%" stopColor={DATA_VIZ_COLORS.success} stopOpacity={0} />
              </linearGradient>
              <linearGradient id="colorReviewed" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={DATA_VIZ_COLORS.primary} stopOpacity={0.8} />
                <stop offset="95%" stopColor={DATA_VIZ_COLORS.primary} stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis label={{ value: "Cards", angle: -90, position: "insideLeft" }} />
            <Tooltip />
            <Legend />
            <Area
              type="monotone"
              dataKey="learned"
              stroke={DATA_VIZ_COLORS.success}
              fillOpacity={1}
              fill="url(#colorLearned)"
              name="Cards Learned"
            />
            <Area
              type="monotone"
              dataKey="reviewed"
              stroke={DATA_VIZ_COLORS.primary}
              fillOpacity={1}
              fill="url(#colorReviewed)"
              name="Cards Reviewed"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
